var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
var FormHelperText = function (_a) {
    var className = _a.className, text = _a.text, _b = _a.error, error = _b === void 0 ? false : _b, rest = __rest(_a, ["className", "text", "error"]);
    var classes = useStyles();
    return (_jsx("div", __assign({}, rest, { className: clsx(classes.root, error && classes.error, className), children: text }), void 0));
};
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: (_a = {
                color: theme.palette.primary.main
            },
            _a[theme.breakpoints.up(500)] = {
                height: 15,
                fontSize: 11
            },
            _a[theme.breakpoints.down(500)] = {
                height: 18,
                fontSize: 14
            },
            _a[theme.breakpoints.up(1600)] = {
                height: 20,
                fontSize: 16
            },
            _a.textAlign = 'left',
            _a),
        error: {
            color: theme.palette.error.main
        }
    });
});
export default FormHelperText;
//# sourceMappingURL=FormHelperText.js.map